export const PageRoute = {
  // Employer Routes
  Employers: "/employers",
  EmployerAdd: "/employers/add",
  EmployerDetail: "/employers/:empId",
  EmployerRecons: "/employers/:empId/recons",
  EmployerEmployees: "/employers/:empId/employees",

  // Employee Routes
  Employees: "/employees",
  EmployeeAdd: "/employees/add",
  EmployeeAddTemporary: "/employees/add-temporary",
  EmployeeDetail: "/employees/:empId",

  // Advance Routes
  Advances: "/advances",
  BlockDates: "/block_dates",
  AdvanceDetail: "/advances/:advId",
  AdvanceBatches: "/advance_batches",
  AdvancePaymentFiles: "/advance_payment_files",
  AdvanceBatchConfigurations: "/advance_batches_configurations",
  SubscriptionBatchConfigurations: "/subscription_batches_configurations",
  SavingsBatches: "/savings_batches",

  // Messages
  Messages: "/messages",
  SmsLogs: "/smslogs",

  // Registrations
  Registrations: "/registrations",
  ColdRegistrationAttempt: "/coldregistrationattempt",

  // Support
  Tickets: "/tickets",
  Leads: "/leads",

  // Tools
  Tools: "/tools",
  MergeProfiles: "/tools/merge-profiles",

  // Security
  Security: "/security",
  // Identity-verification session detail — opened from the Identity
  // Verifications tab on the Security page. Back nav lands on
  // /admin/security#identity-verifications. Per-person detail lives
  // on the EmployeeDetail page (Verification + Identification Documents tabs).
  SecuritySessionDetail: "/security/sessions/:sessionId",

  // Users
  Users: "/users",
  UserBulkUpload: "/users/bulk-upload",
  UserAdd: "/users/add",
  UserPermissions: "/users/permissions",
  UserLogs: "/users/logs",
  UserDetail: "/users/:userId",

  // T&A Roles
  TARoles: "/ta-roles",
  TARoleDetail: "/ta-roles/:roleId",

  // Authentication
  Login: "/login",
  Callback: "/callback",

  // Education Questions
  EducationQuestions: "/questions/education",
  AddEducationQuestion: "/question/add",
  EditEducationQuestion: "/question/education/:questionId",

  // Verification Admin — only the detail pages have routes;
  // lists are surfaced via the Security tab and the per-employee Verification view.
  VerificationPolicyDetail: "/verification/policies/:policyId",

};